import $ from "cash-dom";

export default {
  install(Vue) {
    const createToc = function($el) {
      console.log($el);
      var html = "";
      var indent = "";
      $(".static-page")
        .find("h2, h3, h4, h5")
        .each(function(index) {
          let $this = $(this);
          let tagName = $this[0].tagName;

          console.log(this);
          $this[0].id = "h" + index;

          indent = tagName.substring(1);

          html +=
            '<li class="indent' +
            indent +
            '"><a href="#heading-' +
            index +
            '">' +
            $this.text() +
            "</a></li>";
          $(this)
            .attr("id", "heading-" + index)
            .append(
              '<small><a href="#top" class="to-top"><i class="fa fa-arrow-circle-up" aria-hidden="true"></i> nahoru</a></small>'
            );
        });

      $el.html("<h2>Obsah</h2>" + "<ul>" + html + "</ul>");
    };

    Vue.directive("gd-toc", {
      beforeMount() {},

      mounted(el) {
        console.log("mrdka");
        const $el = $(el);
        createToc($el);
      },

      updated() {}
    });
  }
};
